import axios from 'axios';

const orgBaseURL='http://localhost:8080/api/';
const axiosOrg = axios.create({
  baseURL: orgBaseURL,
  timeout: 10000,
});

class OrgService {
  static baseURL(){
      return orgBaseURL;
  }
  static getOrgs() {
    console.log("getOrgs");
    return axiosOrg.get('orgs').then(res => res.data);
  }
  static getClss(orgId,clsType) {
    console.log("getClss");
    return axiosOrg.get('orgs/' + orgId + '/clss?clsType='+clsType).then(res => res.data);
  }
  static getClssByStd(stdId,clsType) {
    console.log("getClss");
    return axiosOrg.get('stds/' + stdId + '/clss?clsType='+clsType).then(res => res.data);
  }
  static getCls(clsId) {
    console.log("getCls:+clsId");
    return axiosOrg.get('clss/' + clsId).then(res => res.data);
  }  
  static getOrg(id) {
    console.log("getOrg:" + id);
    return axiosOrg.get('orgs/' + id).then(res => res.data);
  }
  static insertOrg(org) {
    org.id = null;
    return axiosOrg.post('orgs', org).then(res => res.data);
  }
  static updateOrg(org) {
    return axiosOrg.post('orgs/'+org.id, org).then(res => res.data);
  }
  static deleteOrg(orgid) {
    return axiosOrg.delete('orgs/' + orgid).then(res => res.data);
  }
  static insertCls(orgId, cls) {
    cls.id = null;
    cls.orgId = orgId;
    return axiosOrg.post('orgs/' + orgId + '/clss', cls).then(res => res.data);
  }
  static insertClss(orgId, cls) {
    cls.forEach(cl => {
      cl.id = null;
      cl.orgId = orgId;
    });
    return axiosOrg.post('orgs/' + orgId + '/clslist', cls).then(res => res.data);
  }
  static deleteClss(clss) {
    console.log('OrgService:deleteClss:' + clss);
    var idList = { ids: clss };
    return axiosOrg.post('clss/deletemulti', idList, { headers: { "Content-Type": "application/json" } }).then(res => res.data);
  }
  static updateCls(cls) {
    return axiosOrg.post('clss/'+cls.id, cls).then(res => res.data);
  }
  static getStds(orgId) {
    return axiosOrg.get('orgs/' + orgId + '/stds').then(res => res.data);
  }
  static getStdsByCls(clsId) {
    return axiosOrg.get('clss/' + clsId + '/stds').then(res => res.data);
  }
  static getStd(id) {
    return axiosOrg.get('stds/' + id).then(res => res.data);
  }
  static getTch(id) {
    return axiosOrg.get('tchs/' + id).then(res => res.data);
  }
  static getTchAccount(id) {
    return axiosOrg.get('tchs/' + id+'/account').then(res => res.data);
  }
  static async setTchMembership(id,groups)
  {
    return axiosOrg.post('tchs/'+id+'/membership',groups).then(res=>res.data);
  }
  static insertStd(orgId, std) {
    std.id = null;
    std.orgId = orgId;
    return axiosOrg.post('orgs/' + orgId + '/stds?clsId=' + std.clsId, std).then(res => res.data);
  }
  static unregisterStudents(orgId,stds,unreg)
  {
    unreg.ids = stds;
    return axiosOrg.post('orgs/'+orgId+'stds/unregister',unreg).then(res => res.data);
  }
  static changeCls(orgId,stds,clsId)
  {
    var ch={ids:stds,clsId:clsId};
    return axiosOrg.post('/orgs/'+orgId+'/stds/changeCls',ch).then(res => res.data);
  }
  static registerToPrg(orgId,stds,clsId)
  {
    var ch={ids:stds,clsId:clsId};
    return axiosOrg.post('orgs/'+orgId+'/stds/registerToPrg',ch).then(res => res.data);
  }

  static updateStd(std) {
    return axiosOrg.post('stds/'+std.id, std).then(res => res.data);
  }
  static updateStdAttrs(stdId,attrs) {
    return axiosOrg.post('stds/'+stdId+'/attrs', attrs).then(res => res.data);
  }

  static updateTch(tch) {
    return axiosOrg.post('tchs/'+tch.id, tch).then(res => res.data);
  }
  static getTchs(orgId) {
    return axiosOrg.get('orgs/' + orgId + '/tchs').then(res => res.data);
  }
  static insertTch(orgId,tch) {
    tch.id = null;
    tch.orgId = orgId;
    return axiosOrg.post('orgs/' + orgId + '/tchs', tch).then(res => res.data);
  }
  static createTchDat(tchId,file,contentType,progressHandler) {
    var formData = new FormData();
    formData.append("fileName",file.name);
    formData.append("file",file);
    formData.append("fileType",file.type);
    formData.append("contentType",contentType);
    const config = {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: progressHandler
    }
    return axiosOrg.post('tchs/'+tchId+'/dats',formData,config).then(res => res.data);
  }  
  static insertCrs(orgId, addCrs) {
    return axiosOrg.post('orgs/' + orgId + '/crss', addCrs).then(res => res.data);
  }
  static updateCrs(crs) {
    return axiosOrg.post('crss/'+crs.id, crs).then(res => res.data);
  }
  static deleteCrss(crss) {
    console.log('OrgService:deleteCrss:' + crss);
    var idList = { ids: crss };
    return axiosOrg.post('crss/deletemulti', idList, { headers: { "Content-Type": "application/json" } }).then(res => res.data);
  }  
  static getCrss(orgId,termId) {
    if(termId == undefined)
      return axiosOrg.get('orgs/' + orgId + '/crss').then(res => res.data);
    return axiosOrg.get('orgs/' + orgId + '/crss?termId='+termId).then(res => res.data);
  }
  static getCrs(crsId) {
    return axiosOrg.get('crss/' + crsId).then(res => res.data);
  }
  static getCrssByStd(stdId,termId) {
    if(termId == undefined || termId == 0)
      return axiosOrg.get('stds/' + stdId + '/crss').then(res => res.data);
    else
      return axiosOrg.get('stds/' + stdId + '/crss?termId='+termId).then(res => res.data);
  }
  static getCrssByTch(tchId,termId) {
    console.log('OrgService:getClsCrssByTch:' + tchId);
    if(termId == undefined || termId == 0)
      return axiosOrg.get('tchs/' + tchId + '/crss').then(res => res.data);
    else
      return axiosOrg.get('tchs/' + tchId + '/crss?termId='+termId).then(res => res.data);
  }
  static getClsCrssByCls(clsId) {
    console.log('OrgService:getClsCrssByCls:' + clsId);
    return axiosOrg.get('clss/' + clsId + '/crss').then(res => res.data);
  }
  static getClsCrssByOrg(orgId,unassignedOnly,electiveOnly) {
    console.log('OrgService:getClsCrssByOrg:' + orgId);
    return axiosOrg.get('orgs/' + orgId + '/clscrss?unassignedOnly='+unassignedOnly+'&electiveOnly='+electiveOnly).then(res => res.data);
  }
  static getClsCrssByCrs(crsId) {
    console.log('OrgService:getClsCrssByCrs:' + crsId);
    return axiosOrg.get('crss/' + crsId + '/sects').then(res => res.data);
  }
  static insertClsCrs(crsId, addClsCrs) {
    return axiosOrg.post('crss/' + crsId + '/sects', addClsCrs).then(res => res.data);
  }
  static assignCrssToTch(tchId, clscrss) {
    var idList = { ids: clscrss };
    return axiosOrg.post('tchs/' + tchId + '/clscrss', idList).then(res => res.data);
  }
  static assignCrssToStd(stdId, clscrss) {
    var idList = { ids: clscrss };
    return axiosOrg.post('stds/' + stdId + '/clscrss', idList).then(res => res.data);
  }
  static unassignCrssFromTch(tchId, clscrss) {
    var idList = { ids: clscrss };
    return axiosOrg.post('tchs/' + tchId + '/clscrss/delete', idList).then(res => res.data);
  }
  static updateClsCrs(addClsCrs) {
    console.log('OrgService:updateClsCrs:' + JSON.stringify(addClsCrs));
    return axiosOrg.post('clscrss/' + addClsCrs.id, addClsCrs).then(res => res.data);
  }
  static createStdDat(stdId,file,contentType,progressHandler) {
    var formData = new FormData();
    formData.append("fileName",file.name);
    formData.append("file",file);
    formData.append("fileType",file.type);
    formData.append("contentType",contentType);
    const config = {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: progressHandler
    }
    return axiosOrg.post('stds/'+stdId+'/dats',formData,config).then(res => res.data);
  }
  static uploadStdData(orgId,loadData,progressHandler)
  {
    var formData = new FormData();
    formData.append("fileName",loadData.file.name);
    formData.append("file",loadData.file);
    formData.append("fileType",loadData.file.type);
    formData.append("separator",loadData.separator);
    formData.append("updateExisting",loadData.updateExisting);
    formData.append("skipFirstRow",loadData.skipFirstRow);
    formData.append("pkey",loadData.pkey);

    const config = {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: progressHandler
    }
    return axiosOrg.post('orgs/'+orgId+'/stds/load',formData,config).then(res => res.data);
  }
  static uploadStdDataColMap(orgId,procId,colMap)
  {
    return axiosOrg.post('orgs/'+orgId+'/stds/load/'+procId+'/colmap',colMap).then(res => res.data);
  }
  static getStdLoadData(orgId,procId)
  {
    return axiosOrg.get('orgs/'+orgId+'/stds/load/'+procId).then(res => res.data);
  }
  static loadStdDataCheck(orgId,procId)
  {
    return axiosOrg.post('orgs/'+orgId+'/stds/load/'+procId+'/check').then(res => res.data);
  }
  static loadStdDataCommit(orgId,procId)
  {
    return axiosOrg.post('orgs/'+orgId+'/stds/load/'+procId+'/commit').then(res => res.data);
  }
  static uploadTchData(orgId,loadData,progressHandler)
  {
    var formData = new FormData();
    formData.append("fileName",loadData.file.name);
    formData.append("file",loadData.file);
    formData.append("fileType",loadData.file.type);
    formData.append("separator",loadData.separator);
    formData.append("updateExisting",loadData.updateExisting);
    formData.append("skipFirstRow",loadData.skipFirstRow);
    formData.append("pkey",loadData.pkey);

    const config = {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: progressHandler
    }
    return axiosOrg.post('orgs/'+orgId+'/tchs/load',formData,config).then(res => res.data);
  }
  static uploadTchDataColMap(orgId,procId,colMap)
  {
    return axiosOrg.post('orgs/'+orgId+'/tchs/load/'+procId+'/colmap',colMap).then(res => res.data);
  }
  static getTchLoadData(orgId,procId)
  {
    return axiosOrg.get('orgs/'+orgId+'/tchs/load/'+procId).then(res => res.data);
  }
  static loadTchDataCheck(orgId,procId)
  {
    return axiosOrg.post('orgs/'+orgId+'/tchs/load/'+procId+'/check').then(res => res.data);
  }
  static loadTchDataCommit(orgId,procId)
  {
    return axiosOrg.post('orgs/'+orgId+'/tchs/load/'+procId+'/commit').then(res => res.data);
  }  
  static getProc(id)
  {
    return axiosOrg.get('procs/'+id).then(res => res.data);
  }
  static getPrntsByStd(stdId) {
    console.log("getPrntsByStd");
    return axiosOrg.get('stds/' + stdId + '/prnts').then(res => res.data);
  }
  static insertStdPrnt(stdId,stdprnt) {
    return axiosOrg.post('stds/' + stdId + '/prnts', stdprnt).then(res => res.data);
  }
  static updateStdPrnt(stdId,stdprnt) {
    return axiosOrg.post('stds/' + stdId + '/prnts', stdprnt).then(res => res.data);
  }
  static deleteStdPrnt(stdId,stdprnt) {
    var idList = { ids: [stdprnt.prntId] };
    return axiosOrg.post('stds/' + stdId + '/prnts/delete', idList).then(res => res.data);
  }
  static searchPrnts(searchPrnt) {
    return axiosOrg.post('prnts/search', searchPrnt).then(res => res.data);
  }
  static searchStds(searchStd) {
    return axiosOrg.post('stds/search', searchStd).then(res => res.data);
  }
  static searchTchs(searchTch) {
    return axiosOrg.post('tchs/search', searchTch).then(res => res.data);
  }
  static getStdDats(stdId) {
    console.log('OrgService:getStdDats:' + stdId);
    return axiosOrg.get('stds/' + stdId + '/dats').then(res => res.data);
  }
  static deleteStdDats(stdId,ids) {
    console.log('OrgService:deleteStdDats:' + ids);
    var idList = { ids: ids };
    return axiosOrg.post('stds/'+stdId+'/dats/delete', idList, { headers: { "Content-Type": "application/json" } }).then(res => res.data);
  }  
  static deleteClsCrssByCrs(crsId,ids) {
    console.log('OrgService:deleteClsCrss:' + ids);
    var idList = { ids: ids };
    return axiosOrg.post('crss/'+crsId+'/sects/delete', idList, { headers: { "Content-Type": "application/json" } }).then(res => res.data);
  }  
  static deleteClsCrssByCls(clsId,ids) {
    console.log('OrgService:deleteClsCrss:' + ids);
    var idList = { ids: ids };
    return axiosOrg.post('clss/'+clsId+'/clscrss/delete', idList, { headers: { "Content-Type": "application/json" } }).then(res => res.data);
  }  

  static getCrsStds(crsId) {
    console.log('OrgService:getCrsStds:' + crsId);
    return axiosOrg.get('crss/' + crsId + '/stds').then(res => res.data);
  }
  static getUdfByEntity(entity)
  {
    return axiosOrg.get('udfs/'+entity).then(res => res.data);
  }
  static insertUdf(udf)
  {
    return axiosOrg.post('udfs',udf).then(res => res.data);
  }
  static updateUdf(udf)
  {
    return axiosOrg.post('udfs/'+udf.id,udf).then(res => res.data);
  }
  static insertStdTableAttr(stdId,udfId,attrs)
  {
    return axiosOrg.post('stds/'+stdId+'/tableattrs/'+udfId,attrs).then(res => res.data);
  }
  static updateStdTableAttr(stdId,udfId,recordId,attrs)
  {
    return axiosOrg.post('stds/'+stdId+'/tableattrs/'+udfId+'/record/'+recordId,attrs).then(res => res.data);
  }  
  static getStdTableAttr(stdId,udfId)
  {
    return axiosOrg.get('stds/'+stdId+'/tableattrs/'+udfId).then(res => res.data);
  }
  static deleteStdTableAttr(stdId,udfId,ids) {
    console.log('OrgService:deleteStdTableAttr:' + ids);
    var idList = { ids: ids };
    return axiosOrg.post('stds/'+stdId+'/tableattrs/'+udfId+'/delete', idList, { headers: { "Content-Type": "application/json" } }).then(res => res.data);
  }    
  static createNewTerm(term)
  {
    term.id = null;
    return axiosOrg.post('terms', term).then(res => res.data);
  }
  static getActiveTerm()
  {
    return axiosOrg.get('term').then(res => res.data);
  }
  static getTermsByStd(stdId) {
    return axiosOrg.get('stds/' + stdId + '/terms').then(res => res.data);
  }
  static getTerms() {
    return axiosOrg.get('terms').then(res => res.data);
  }
  static getTermsByTch(tchId) {
    return axiosOrg.get('tchs/' + tchId + '/terms').then(res => res.data);
  }
  static getEduYears(){
    return axiosOrg.get('eduyears').then(res=>res.data);
  }
  static async createReportDOC(procId,format,detail,settings){
    return axiosOrg.post('reports/'+procId+'/createdoc'+'?format='+format+(detail>0?'&detail='+detail:''),settings).then(res => res.data);
  }
  static async createReport(reportLink,report) {
    return axiosOrg.post(reportLink, report).then(res => res.data);
  }  
  static async reportExportPDF(procId){
    return axiosOrg.get('reports/'+procId+'/pdf',{timeout:100000,responseType:'blob'});
  }
  static async reportExportDOC(procId){
    return axiosOrg.get('reports/'+procId+'/doc',{timeout:100000,responseType:'blob'});
  }
  static async getProcDatDoc(procId){
    return axiosOrg.get('procs/'+procId+'/doc',{timeout:100000,responseType:'blob'});
  }
  static async getProcDatPdf(procId){
    return axiosOrg.get('procs/'+procId+'/pdf',{timeout:100000,responseType:'blob'});
  }
  static async createAccounts(orgId,accountInfo,personIds)
  {
    accountInfo.ids=personIds;
    return axiosOrg.post('orgs/'+orgId+'/createAccounts',accountInfo).then(res => res.data);
  }
  static async getUserGroups()
  {
    return axiosOrg.get('groups').then(res=>res.data);
  }
  static async addUserGroup(grp)
  {
    return axiosOrg.post('groups',grp).then(res=>res.data);
  }
}
export default OrgService;
